import {memo} from 'react';
import {DevToolWrapper} from './DevToolWrapper';
import {TextHeading10} from '../text/TextHeading10';
import {Palette} from 'hubbl-shared';

export const DevToolFloatingId = memo(({id}: {id: string}) => {
  return (
    <DevToolWrapper>
      <div style={{position: 'absolute', top: 0, right: 0}}>
        <TextHeading10 color={Palette.almostBlackTransparent5} text={id} />
      </div>
    </DevToolWrapper>
  );
});
